import type { KeyboardEvent as ReactKeyboardEvent } from 'react';

// ---------------------------------------------------------------------------
// Taste Entf löscht: überall, wo es ein „Löschen“ gibt – das gewählte Objekt (Arbeitsfläche, `useDeleteActions`) bzw. die Zeile, Karte
// oder der Eintrag mit dem Fokus (`onDeleteKey`). Immer mit Rückfrage. Beim Schreiben (Eingabefeld, Texteditor) bleibt Entf, was es ist.
// ---------------------------------------------------------------------------

/** Felder, in denen Entf ein Zeichen löscht – alle Eingaben außer Kästchen, Knöpfen und Reglern */
const NOT_TEXT = new Set(['checkbox', 'radio', 'button', 'submit', 'reset', 'range', 'color', 'file', 'image']);

/** Wird gerade geschrieben (Eingabefeld, Auswahlliste, Texteditor)? Dann gehört Entf dem Feld. */
export function isTyping(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  if (target.isContentEditable || target.closest('[contenteditable="true"], .ProseMirror')) return true;
  if (target instanceof HTMLTextAreaElement || target instanceof HTMLSelectElement) return true;
  return target instanceof HTMLInputElement && !NOT_TEXT.has(target.type);
}

/** Entf ohne Strg, Alt, ⌘ – nicht beim Schreiben */
export const isDeleteKey = (e: { key: string; altKey: boolean; ctrlKey: boolean; metaKey: boolean; target: EventTarget | null }): boolean =>
  e.key === 'Delete' && !e.altKey && !e.ctrlKey && !e.metaKey && !isTyping(e.target);

/**
 * `onKeyDown` für eine Zeile, Karte oder einen Eintrag mit eigenem Löschen: Entf, solange der Fokus darin ist, ruft `fn` (die selbst
 * nachfragt) – und nur sie, nicht auch das Löschen des gewählten Objekts.
 */
export const onDeleteKey =
  (fn: (() => void) | null | undefined) =>
  (e: ReactKeyboardEvent): void => {
    if (!fn || !isDeleteKey(e)) return;
    e.preventDefault();
    e.stopPropagation();
    fn();
  };

/** Ist ein Fenster offen (dann gilt Entf nicht für das gewählte Objekt dahinter)? */
export const modalOpen = (): boolean => document.querySelector('[role="dialog"][aria-modal="true"]') !== null;
